import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { FeedbackStudentGridDataService } from 'common/services/data-services/admin/feedback-student/feedback-student-data.service';
import { FeedbackStudentModel } from 'common/models/page-models/Feedback Students Model/feedback-student-data.model';
import { FeedbackStudentGridMetaModel } from 'common/models/page-models/Feedback Students Model/feedback-student-grid-meta.model';
import { FeedbackStudentListingModel } from 'common/models/page-models/Feedback Students Model/feedback-student-params.model';

@Injectable({
    providedIn: 'root'
})
export class FeedbackStudentWidgetService extends GridWidgetService<FeedbackStudentModel, FeedbackStudentListingModel> {
    constructor(protected override  ds: FeedbackStudentGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new FeedbackStudentGridMetaModel().getMetaModel();
        return meta;
    }
}